import React from 'react';

import { Button, Select, Space } from 'antd';

import { BoxOtaActiveProgress } from './BoxOtaActiveProgress';
import { BoxOtaHistory } from './BoxOtaHistory';
import { useBoxOtaView } from '../hooks/useBoxOtaView';
import ScopedCta from '@/components/ScopedCta';
import { scopes } from '@/config';

interface IBoxOtaProps {
  lpUI: string;
}

export const BoxOta = ({ lpUI }: IBoxOtaProps) => {
  const {
    firmwareOptions,
    isFirmwaresLoading,
    selectedFirmware,
    setSelectedFirmware,
    isOtaInProgress,
    isStarting,
    isCancelling,
    handleStart,
    handleCancel,
    handleRefreshHistory,
  } = useBoxOtaView(lpUI);

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Space>
        <Select
          placeholder="Select firmware version"
          options={firmwareOptions}
          loading={isFirmwaresLoading}
          value={selectedFirmware}
          onChange={setSelectedFirmware}
          style={{ width: 200 }}
          data-testid="ota-firmware-select"
        />
        <ScopedCta
          component={Button}
          type="primary"
          loading={isStarting}
          disabled={!selectedFirmware || isCancelling}
          onClick={handleStart}
          requiredScopes={[scopes.MANAGE_OTA]}
          data-testid="ota-start-button"
        >
          Start OTA
        </ScopedCta>
        <ScopedCta
          component={Button}
          danger
          loading={isCancelling}
          disabled={isStarting || !isOtaInProgress}
          onClick={handleCancel}
          requiredScopes={[scopes.MANAGE_OTA]}
          data-testid="ota-cancel-button"
        >
          Cancel OTA
        </ScopedCta>
      </Space>
      <BoxOtaActiveProgress lpUI={lpUI} />
      <BoxOtaHistory
        lpUI={lpUI}
        isOtaInProgress={isOtaInProgress}
        onRefresh={handleRefreshHistory}
      />
    </Space>
  );
};
